export const organizationTypes = {
    FETCH_REQUEST: "ORGANIZATION_FETCH_REQUEST",
    FETCH_SUCCESS: "ORGANIZATION_FETCH_SUCCESS",
    FETCH_FAILURE: "ORGANIZATION_FETCH_FAILURE",
    ALARM_COUNT_SUCCESS: "ORGANIZATION_ALARM_COUNT_SUCCESS",
    DOWNLOAD_REQUEST: "ORGANIZATION_DOWNLOAD_REQUEST",
    DOWNLOAD_SUCCESS: "ORGANIZATION_DOWNLOAD_SUCCESS",
    DOWNLOAD_FAILURE: "ORGANIZATION_DOWNLOAD_FAILURE",
    SET_CURRENT_MODAL: 'SET_CURRENT_MODAL',
    UPDATE_PAGINATION_REQUEST: "ORGANIZATION_UPDATE_PAGINATION_REQUEST",
};

export const setCurrentModal = (data) => ({
    type: organizationTypes.SET_CURRENT_MODAL,
    payload: data,
});

export const fetchRequest = () => ({
    type: organizationTypes.FETCH_REQUEST,
});

export const fetchSuccess = (resp) => ({
    type: organizationTypes.FETCH_SUCCESS,
    payload: resp
});

export const locationAlarmCountSuccess = (resp) => ({
    type: organizationTypes.ALARM_COUNT_SUCCESS,
    payload: resp
});

export const fetchFailure = (resp) => ({
    type: organizationTypes.FETCH_FAILURE,
    payload: resp
});

export const downloadRequest = () => ({
    type: organizationTypes.DOWNLOAD_REQUEST
});

export const downloadSuccess = (resp) => ({
    type: organizationTypes.DOWNLOAD_SUCCESS,
    payload: resp
});

export const downloadFailure = (error) => ({
    type: organizationTypes.DOWNLOAD_FAILURE,
    payload: error
});
export const updatePaginationRequest = (req) => ({
    type: organizationTypes.UPDATE_PAGINATION_REQUEST,
    payload: req
});